import { defineStore } from 'pinia';
import { ref } from 'vue';
import { api, ApiCallError } from '@/api/client';
import type { Generation, GenerationsPage, GenerationType } from '@/api/types';

export type HistoryFilter = 'all' | GenerationType;

export const useHistoryStore = defineStore('history', () => {
  const items = ref<Generation[]>([]);
  const filter = ref<HistoryFilter>('all');
  const cursor = ref<string | null>(null);
  const exhausted = ref(false);
  const loading = ref(false);
  const error = ref<string | null>(null);

  async function loadFirst(f: HistoryFilter = filter.value) {
    filter.value = f;
    items.value = [];
    cursor.value = null;
    exhausted.value = false;
    await loadMore();
  }

  async function loadMore() {
    if (loading.value || exhausted.value) return;
    loading.value = true;
    error.value = null;
    try {
      const params = new URLSearchParams({ type: filter.value, limit: '20' });
      if (cursor.value) params.set('cursor', cursor.value);
      const page = await api.get<GenerationsPage>(`/generations?${params}`);
      items.value.push(...page.items);
      cursor.value = page.next_cursor;
      exhausted.value = page.next_cursor === null;
    } catch (e) {
      error.value = e instanceof ApiCallError ? e.message : 'Не удалось загрузить историю';
    } finally {
      loading.value = false;
    }
  }

  return { items, filter, cursor, exhausted, loading, error, loadFirst, loadMore };
});
